module.exports = __webpack_public_path__ + "img/nav-about-movie@2x.94e713d.webp";